// Module
var code = "<div class=\"dialog-header\"><h1>Diagnosis Reference</h1></div><div class=\"dialog-body\"><img class=\"img-responsive\" ng-src=\"{{ngDialogData.image}}\" style=\"width:100%\"></div>";
// Exports
var _module_exports =code;;
var path = 'app/views/visits/detail/sections/photos/photos.diagnosis.html';
var angular = require('angular');
angular.module('pims').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
export default path;